import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

export default function WidgetFrame({ title, icon, children, onRemove, isEditing }) {
  return (
    <Card sx={{
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: "#ffffff",
      border: isEditing ? "2px solid rgba(0,117,255,0.5)" : "1px solid #c8ddf0",
      borderRadius: "16px",
      overflow: "hidden",
      boxShadow: "0 2px 12px rgba(0,87,216,0.08)",
      transition: "border 0.2s",
    }}>
      {/* Drag handle header */}
      <VuiBox
        className="drag-handle"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={2}
        py={1.2}
        sx={{
          cursor: isEditing ? "grab" : "default",
          borderBottom: "1px solid #b0c8e0",
          minHeight: 44,
          flexShrink: 0,
          userSelect: "none",
        }}
      >
        <VuiBox display="flex" alignItems="center" gap={1}>
          {icon && (
            <VuiTypography sx={{ fontSize: "1rem", lineHeight: 1 }}>{icon}</VuiTypography>
          )}
          <VuiTypography variant="button" color="text" fontWeight="bold" sx={{ fontSize: "0.82rem" }}>
            {title}
          </VuiTypography>
        </VuiBox>
        {onRemove && (
          <IconButton
            size="small"
            aria-label={`Remove ${title} widget`}
            onClick={(e) => { e.stopPropagation(); onRemove(); }}
            sx={{
              color: "#b0c4d8",
              p: 0.4,
              "&:hover": { color: "#f44336", background: "rgba(244,67,54,0.1)" },
            }}
          >
            <span aria-hidden="true" style={{ fontSize: "1rem", lineHeight: 1, fontWeight: 700 }}>×</span>
          </IconButton>
        )}
      </VuiBox>
      {/* Content area */}
      <VuiBox sx={{ flex: 1, overflow: "auto", minHeight: 0 }}>
        {children}
      </VuiBox>
    </Card>
  );
}

